import { useEffect, useState } from 'react';

const hasUrlDefaultValues = (): boolean => {
  const searchParams = new URLSearchParams(window.location.search);
  const filters = searchParams.get('filters');
  const segment = searchParams.get('segment');
  const view = searchParams.get('view');
  const withActiveFilters = filters && filters.includes('AND');

  if (segment || view || withActiveFilters) {
    return false;
  }

  return true;
};

export const useExperimentVisibilityForTargetedCustomers = (
  isExperimentEnabled: boolean,
): {
  shouldDisplayOverview: boolean;
  resetFilterInteraction: () => void;
  enableFilterInteraction: () => void;
} => {
  const [shouldDisplayOverview, setShouldDisplayOverview] = useState(false);
  const [hadFilterInteraction, setHadFilterInteraction] = useState(false);

  useEffect(() => {
    // Fail fast in case experiment is disabled
    if (!isExperimentEnabled) {
      setShouldDisplayOverview(false);
      return;
    }

    const isUrlWithDefaultValues = hasUrlDefaultValues();
    if (isExperimentEnabled && isUrlWithDefaultValues && !hadFilterInteraction) {
      setShouldDisplayOverview(true);
      return;
    }

    if (isExperimentEnabled && !isUrlWithDefaultValues) {
      setHadFilterInteraction(true);
    }

    setShouldDisplayOverview(false);
  }, [isExperimentEnabled, hadFilterInteraction]);

  return {
    shouldDisplayOverview,
    resetFilterInteraction: () => {
      setHadFilterInteraction(false);
    },
    enableFilterInteraction: () => {
      setHadFilterInteraction(true);
    },
  };
};
